import { __assign, __rest } from "tslib";
import React from "react";
import VeltCommentDialogComposerActionButton from "./VeltCommentDialogComposerActionButton/VeltCommentDialogComposerActionButton";
import VeltCommentDialogComposerAssignUser from "./VeltCommentDialogComposerAssignUser/VeltCommentDialogComposerAssignUser";
import VeltCommentDialogComposerAttachments from "./VeltCommentDialogComposerAttachments/VeltCommentDialogComposerAttachments";
import VeltCommentDialogComposerInput from "./VeltCommentDialogComposerInput/VeltCommentDialogComposerInput";
import VeltCommentDialogComposerRecordings from "./VeltCommentDialogComposerRecordings/VeltCommentDialogComposerRecordings";
import VeltCommentDialogComposerPrivateBadge from "./VeltCommentDialogComposerPrivateBadge/VeltCommentDialogComposerPrivateBadge";
import VeltCommentDialogComposerAvatar from "./VeltCommentDialogComposerAvatar/VeltCommentDialogComposerAvatar";
import VeltCommentDialogComposerFormatToolbar from "./VeltCommentDialogComposerFormatToolbar/VeltCommentDialogComposerFormatToolbar";
import { transformWireframeProps } from "../../../utils/propUtils";
;
var VeltCommentDialogComposer = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposer.ActionButton = VeltCommentDialogComposerActionButton;
VeltCommentDialogComposer.AssignUser = VeltCommentDialogComposerAssignUser;
VeltCommentDialogComposer.Attachments = VeltCommentDialogComposerAttachments;
VeltCommentDialogComposer.Input = VeltCommentDialogComposerInput;
VeltCommentDialogComposer.Recordings = VeltCommentDialogComposerRecordings;
VeltCommentDialogComposer.PrivateBadge = VeltCommentDialogComposerPrivateBadge;
VeltCommentDialogComposer.Avatar = VeltCommentDialogComposerAvatar;
VeltCommentDialogComposer.FormatToolbar = VeltCommentDialogComposerFormatToolbar;
export default VeltCommentDialogComposer;
